'use client';
import ReactCountdown, { CountdownRenderProps } from 'react-countdown';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

type CountdownProps = {
  countdownEnd: Date;
  segmentValueClass?: string;
  segmentTitleClass?: string;
  className?: string;
  size?: 'small' | 'large';
};

export const Countdown = ({
  countdownEnd,
  segmentValueClass,
  segmentTitleClass,
  className,
  size = 'small',
}: CountdownProps) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: CountdownRenderProps) => {
    const segments = [
      { title: 'Dager', value: days },
      { title: 'Timer', value: hours },
      { title: 'Minutter', value: minutes },
      { title: 'Sekunder', value: seconds },
    ];

    return (
      <ul
        className={twMerge(clsx('flex flex-row gap-0.5 lg:gap-2.5', className))}
      >
        {segments.map((segment) => (
          <li
            className={twMerge(
              clsx('flex flex-col', {
                'gap-0.5 lg:gap-2.5': size === 'small',
                'gap-0.5 lg:gap-1': size === 'large',
              })
            )}
          >
            <div
              className={twMerge(
                clsx(
                  'bg-white text-black flex items-center justify-center',
                  'font-heading font-500',
                  segmentValueClass,
                  {
                    'w-9 h-7 lg:w-24 lg:h-20 text-[18px] lg:text-[65px]':
                      size === 'small',
                    'w-14 h-11 lg:w-28 lg:h-24 text-[27px] lg:text-[78px]':
                      size === 'large',
                  }
                )
              )}
            >
              {isClient && segment.value}
            </div>
            <span
              className={twMerge(
                clsx('font-sans font-bold', segmentTitleClass, {
                  'text-[7px] lg:text-base': size === 'small',
                  'text-[9px] lg:cap-base': size === 'large',
                })
              )}
            >
              {segment.title}
            </span>
          </li>
        ))}
      </ul>
    );
  };
  return (
    <div>
      <ReactCountdown date={countdownEnd} renderer={renderer} />
    </div>
  );
};
